var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2952 4.28868C12.688 3.9005 13.3212 3.90428 13.7094 4.29713C14.0975 4.68998 14.0938 5.32313 13.7009 5.71132L6.32469 13H24C24.5523 13 25 13.4477 25 14C25 14.5523 24.5523 15 24 15H6.32697L13.7009 22.2864C14.0938 22.6746 14.0975 23.3078 13.7094 23.7006C13.3212 24.0935 12.688 24.0972 12.2952 23.7091L3.36818 14.888C2.87296 14.3987 2.87296 13.5991 3.36818 13.1097L12.2952 4.28868Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.a0b842f49c5ba07274ebb488fcdd9399.svg";
export { ForwardRef as ReactComponent };